import { ListItemText } from "@mui/material";
import React from "react";

import type { SidebarMenuItemTextProps } from "./types";

// Personalizza questi colori
const TEXT_COLOR = "#e2e8f0"; // Colore testo (grigio chiaro)
const TEXT_ACTIVE_COLOR = "#ffffff"; // Colore testo selezionato (bianco)

export const SidebarMenuItemText: React.FC<SidebarMenuItemTextProps> = ({
  text,
  isSelected,
}) => {
  return (
    <ListItemText
      primary={text}
      sx={{
        "& .MuiListItemText-primary": {
          color: isSelected ? TEXT_ACTIVE_COLOR : TEXT_COLOR,
          fontWeight: isSelected ? 600 : 500,
        },
        whiteSpace: "nowrap",
      }}
    />
  );
};
